<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <div class="page-header mb-4">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="page-title text-dark font-weight-bold">
              Gửi Phản Ánh / Ý kiến
            </h3>
            <ul class="breadcrumb bg-transparent p-0 mt-1">
              <li class="breadcrumb-item">
                <router-link to="/" class="text-muted text-decoration-none"
                  >Trang chủ</router-link
                >
              </li>
              <li class="breadcrumb-item active text-dark">Tạo báo cáo</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-10 col-md-10">
          <div class="card modern-card border-0">
            <div class="card-header bg-gray-50 border-bottom-0 py-4 px-4">
              <div class="d-flex align-items-center">
                <div class="icon-circle bg-white shadow-sm mr-3">
                  <i class="fa fa-pencil text-primary"></i>
                </div>
                <div>
                  <h5 class="card-title mb-1 font-weight-bold text-dark">
                    Thông tin báo cáo
                  </h5>
                  <p class="text-muted small mb-0">
                    Hệ thống sẽ ghi nhận và xử lý phản hồi của bạn sớm nhất.
                  </p>
                </div>
              </div>
            </div>

            <div class="card-body p-4">
              <form @submit.prevent="handleSubmit">
                <div class="form-group mb-4">
                  <label
                    class="form-label text-uppercase text-secondary small font-weight-bold"
                  >
                    Phân loại <span class="text-danger">*</span>
                  </label>
                  <div class="input-group-custom">
                    <select
                      v-model="form.danhMucId"
                      class="form-control custom-select-box"
                      @change="handleCategoryChange"
                      required
                    >
                      <option :value="null" disabled>
                        -- Chọn loại báo cáo --
                      </option>
                      <option
                        v-for="cat in listDanhMuc"
                        :key="cat.id"
                        :value="cat.id"
                      >
                        {{ cat.tenDanhMuc }}
                      </option>
                    </select>
                    <span class="select-arrow"
                      ><i class="fa fa-chevron-down"></i
                    ></span>
                  </div>

                  <transition name="fade">
                    <div
                      v-if="selectedCategory"
                      class="mt-2 pl-1 d-flex align-items-start"
                    >
                      <i class="fa fa-info-circle text-info mt-1 mr-2"></i>
                      <small class="text-muted">
                        {{ selectedCategory.moTa }}
                      </small>
                    </div>
                  </transition>
                </div>

                <div class="form-group mb-4">
                  <div
                    class="anonymous-box p-3 rounded d-flex align-items-center justify-content-between"
                  >
                    <div class="mr-3">
                      <span
                        class="font-weight-bold text-dark"
                        style="font-size: 0.95rem"
                        >Chế độ ẩn danh</span
                      >
                      <div class="text-muted small mt-1 line-height-sm">
                        <span v-if="!selectedCategory"
                          >Vui lòng chọn loại báo cáo ở trên.</span
                        >
                        <span v-else-if="canBeAnonymous"
                          >Danh tính của bạn sẽ được bảo mật tuyệt đối.</span
                        >
                        <span v-else class="text-warning font-weight-medium">
                          <i class="fa fa-exclamation-triangle"></i> Loại báo
                          cáo này yêu cầu công khai danh tính.
                        </span>
                      </div>
                    </div>

                    <div
                      class="custom-control custom-switch custom-switch-lg"
                      v-if="canBeAnonymous"
                    >
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="anDanhSwitch"
                        v-model="form.muonAnDanh"
                      />
                      <label
                        class="custom-control-label cursor-pointer"
                        for="anDanhSwitch"
                      ></label>
                    </div>
                    <div
                      class="custom-control custom-switch custom-switch-lg opacity-50"
                      v-else
                    >
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        disabled
                      />
                      <label class="custom-control-label"></label>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-4">
                  <label
                    class="form-label text-uppercase text-secondary small font-weight-bold"
                  >
                    Tiêu đề <span class="text-danger">*</span>
                  </label>
                  <input
                    v-model="form.tieuDe"
                    type="text"
                    class="form-control modern-input"
                    placeholder="Tóm tắt vấn đề (Ví dụ: Hỏng máy lạnh phòng họp...)"
                    required
                  />
                </div>

                <div class="form-group mb-4">
                  <label
                    class="form-label text-uppercase text-secondary small font-weight-bold"
                  >
                    Nội dung chi tiết <span class="text-danger">*</span>
                  </label>
                  <textarea
                    v-model="form.noiDung"
                    class="form-control modern-input"
                    rows="5"
                    placeholder="Mô tả chi tiết vấn đề, thời gian, địa điểm xảy ra..."
                    required
                  ></textarea>
                </div>

                <div class="form-group mb-2">
                  <label
                    class="form-label text-uppercase text-secondary small font-weight-bold"
                  >
                    Đính kèm tệp (Nếu có)
                  </label>
                  <FileUploader
                    v-model="selectedFiles"
                    :is-uploading="isUploading"
                    multiple
                    accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx"
                  />
                </div>
              </form>
            </div>

            <div
              class="card-footer bg-white border-top-0 px-4 pb-4 pt-0 text-right"
            >
              <div class="d-flex justify-content-end align-items-center">
                <router-link
                  to="/gop-y-kien-nghi/lich-su"
                  class="btn btn-light text-muted mr-3 font-weight-medium px-4 rounded-pill border-0"
                >
                  Hủy
                </router-link>
                <button
                  class="btn btn-primary px-5 rounded-pill shadow-lg-primary"
                  @click="handleSubmit"
                  :disabled="isSubmitting || isUploading"
                >
                  <span v-if="isSubmitting"
                    ><i class="fa fa-spinner fa-spin mr-2"></i> Đang gửi</span
                  >
                  <span v-else
                    >Gửi Báo Cáo <i class="fa fa-paper-plane ml-1"></i
                  ></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from "vue";
import baoCaoService from "@/services/gopYKienNghiService";
import fileService from "@/services/fileService";
import { useToast } from "vue-toastification";
import { useRouter } from "vue-router";
import FileUploader from "@/components/FileUploader.vue";

const toast = useToast();
const router = useRouter();
const listDanhMuc = ref([]);
const isUploading = ref(false);
const isSubmitting = ref(false);
const selectedFiles = ref([]);

const form = reactive({
  tieuDe: "",
  noiDung: "",
  danhMucId: null,
  danhSachAnh: [],
  muonAnDanh: false,
});

const selectedCategory = computed(() => {
  return listDanhMuc.value.find((c) => c.id === form.danhMucId);
});

const canBeAnonymous = computed(() => {
  return selectedCategory.value ? selectedCategory.value.choPhepAnDanh : false;
});

const handleCategoryChange = () => {
  if (!canBeAnonymous.value) {
    form.muonAnDanh = false;
  }
};

const handleSubmit = async () => {
  if (!form.danhMucId || !form.tieuDe.trim() || !form.noiDung.trim()) {
    toast.warning("Vui lòng điền đầy đủ các trường bắt buộc.");
    return;
  }
  isSubmitting.value = true;
  form.danhSachAnh = [];
  try {
    if (selectedFiles.value.length > 0) {
      isUploading.value = true;
      const formData = new FormData();
      for (let i = 0; i < selectedFiles.value.length; i++) {
        formData.append("files", selectedFiles.value[i]);
      }
      formData.append("folderName", "gop_y_bao_cao");
      const uploadRes = await fileService.upload(formData);
      if (uploadRes.data && Array.isArray(uploadRes.data)) {
        form.danhSachAnh = uploadRes.data.map((fileObj) => fileObj.location);
      }
      isUploading.value = false;
    }
    await baoCaoService.createBaoCao(form);
    toast.success("Gửi báo cáo thành công!");
    router.push({ name: "LichSuGopYKienNghi" });
  } catch (error) {
    console.error(error);
    const errorMsg =
      error.response?.data?.message || error.message || "Gửi thất bại.";
    toast.error(errorMsg);
  } finally {
    isSubmitting.value = false;
    isUploading.value = false;
  }
};

onMounted(async () => {
  try {
    const res = await baoCaoService.getDanhMucActive();
    listDanhMuc.value = res.data;
  } catch (error) {
    console.error("Lỗi tải danh mục:", error);
    toast.error("Không thể tải danh sách loại báo cáo.");
  }
});
</script>

<style scoped>
/* --- General Layout --- */
.page-wrapper {
  background-color: #f4f6f8;
  min-height: 100vh;
  padding-bottom: 40px;
}

/* --- Card Styling --- */
.modern-card {
  border-radius: 16px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.03);
  background: #ffffff;
  overflow: visible; /* Để shadow không bị cắt */
}

.card-header.bg-gray-50 {
  background-color: #fafbfc;
  border-radius: 16px 16px 0 0;
}

.icon-circle {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #4a6cf7;
}

/* --- Typography --- */
.text-secondary {
  color: #7e8299 !important;
}
.line-height-sm {
  line-height: 1.4;
}

/* --- Form Inputs --- */
.form-control.modern-input,
.form-control.custom-select-box {
  border: 1px solid #e1e3ea;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 12px 16px;
  font-size: 0.95rem;
  color: #3f4254;
  transition: all 0.2s ease-in-out;
}

.form-control.modern-input:focus,
.form-control.custom-select-box:focus {
  border-color: #4a6cf7;
  box-shadow: 0 0 0 4px rgba(74, 108, 247, 0.1);
  outline: none;
}

/* Custom Select Arrow */
.input-group-custom {
  position: relative;
}
.custom-select-box {
  appearance: none;
  -webkit-appearance: none;
}
.select-arrow {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #b5b5c3;
  font-size: 0.8rem;
}

/* --- Anonymous Box Area (Điểm nhấn chính) --- */
.anonymous-box {
  background-color: #f3f6f9; /* Màu nền tách biệt */
  border: 1px solid transparent;
  transition: background-color 0.3s;
}
/* Hiệu ứng khi được active (có thể ẩn danh) */
.anonymous-box:hover {
  background-color: #eef3f7;
}

/* Custom Switch Lớn hơn */
.custom-switch-lg {
  padding-left: 3.5rem; /* Tăng khoảng cách để chứa nút gạt to */
}
.custom-switch-lg .custom-control-label::before {
  height: 1.75rem;
  width: 3.25rem;
  border-radius: 3rem;
  left: -3.5rem;
  background-color: #ebedf3;
  border: none;
}
.custom-switch-lg .custom-control-label::after {
  width: calc(1.75rem - 6px);
  height: calc(1.75rem - 6px);
  border-radius: 50%;
  left: calc(-3.5rem + 3px);
  top: calc(0.25rem + 3px);
  background-color: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.custom-switch-lg
  .custom-control-input:checked
  ~ .custom-control-label::before {
  background-color: #4a6cf7;
}
.custom-switch-lg .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(1.5rem);
}

/* --- Button Shadow --- */
.shadow-lg-primary {
  box-shadow: 0 8px 15px rgba(74, 108, 247, 0.25);
}

/* --- Animations --- */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}
</style>
